import React, { useEffect, useState } from 'react';
import Auth from './Auth';
import validator from 'validator';


export default function Invite(props) {
  const [email, setEmail] = useState("");
  const [invites, setInvites] = useState([]);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    document.title = "Sudowrite - Invite a Friend";
    getInvites();
  }, []);

  async function getInvites() {
    Auth.fetchWithIdToken("/api/invite/sent", {}).then(data => {
      setInvites(data.emails);
    });
  }

  function updateEmail(e) {
    e.preventDefault();
    setEmail(e.target.value);
  }

  function sendInvite(e) {
    e.preventDefault();

    if (validator.isEmail(email)) {
      console.log("sending");
      Auth.fetchWithIdToken("/api/invite", { emails: [email] }).then(data => {
        setEmail("");

        if (data.rejected.length > 0) {
          setMessage("This email has already been invited.");
        } else {
          setMessage("Invite sent!");
          getInvites();
        }
      });
      setError(null);
    } else {
      setError("Invalid email address. Please try again.");
      setMessage(null);
    }

  }

  return (
    <div id="invite">
      <section>
        <h2>Invite a Friend</h2>

        <p>Got a friend who you think would be a great fit for Sudowrite? Invite them to our beta! We're looking for folks who are working on any kind of creative writing and who are open to introducing a friendly AI into their workflow.</p>

        <form onSubmit={sendInvite}>
          <input type="text" placeholder="Email address" onChange={updateEmail} value={email} />
          <button>Send Invite</button>

          {error &&
            <div className="error">{error}</div>
          }

          {message &&
            <div className="message">{message}</div>
          }
        </form>

        {invites.length > 0 &&
          <>
            <h3>Invites Sent</h3>

            <ul>
              {invites.map(email => {
                return <li key={email}>{email}</li>;
              })}
            </ul>
          </>
        }


      </section>

    </div>
  );

}
